import {
	Component,
	OnInit,
	HostListener,
	ViewChild,
	Input,
	ElementRef,
	OnDestroy,
	ViewChildren,
	QueryList,
} from '@angular/core';
import { Router, NavigationEnd } from '@angular/router';
import { ConfigService } from '../../services/config/config.service';
import { DeviceService } from '../../services/device/device.service';
import { CommonService } from 'src/app/services/common/common.service';
import { AppNotification } from 'src/app/data-models/common/app-notification.model';
import { LocalStorageKey } from 'src/app/enums/local-storage-key.enum';
import { VantageShellService } from '../../services/vantage-shell/vantage-shell.service';
import { LoggerService } from 'src/app/services/logger/logger.service';
import { InputAccessoriesService } from 'src/app/services/input-accessories/input-accessories.service';
import { InputAccessoriesCapability } from 'src/app/data-models/input-accessories/input-accessories-capability.model';
import { LanguageService } from 'src/app/services/language/language.service';
import { NgbModal, NgbDropdown } from '@ng-bootstrap/ng-bootstrap';
import { AdPolicyService } from 'src/app/services/ad-policy/ad-policy.service';
import { AdPolicyId } from 'src/app/enums/ad-policy-id.enum';
import { Observable, Subscription } from 'rxjs';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { TopRowFunctionsIdeapadService } from '../pages/page-device-settings/children/subpage-device-settings-input-accessory/top-row-functions-ideapad/top-row-functions-ideapad.service';
import { catchError, map, tap } from 'rxjs/operators';
import { MenuChange } from 'src/app/enums/menuChange.enum';
import { DashboardService } from 'src/app/services/dashboard/dashboard.service';
import { CardService } from 'src/app/services/card/card.service';
import { BacklightService } from '../pages/page-device-settings/children/subpage-device-settings-input-accessory/backlight/backlight.service';
import { StringBooleanEnum } from '../../data-models/common/common.interface';
import { BacklightLevelEnum } from '../pages/page-device-settings/children/subpage-device-settings-input-accessory/backlight/backlight.enum';
import { DialogService } from 'src/app/services/dialog/dialog.service';
import { ModernPreloadService } from 'src/app/services/modern-preload/modern-preload.service';
import { IMenuItem } from 'src/app/services/config/menu-item.interface';
import { PowerPage } from 'src/app/presenters/user-cases/power-page/power-page';
import { EMachineType } from 'src/app/enums/machine-type.enum';
import { TopRowFunctionFeature } from 'src/app/presenters/user-cases/input-accessories/intelligent-keyboard/top-row-function/top-row-function-feature';

@Component({
	selector: 'vtr-menu-main',
	templateUrl: './menu-main.component.html',
	styleUrls: ['./menu-main.component.scss'],
})
export class MenuMainComponent implements OnInit, OnDestroy {
	@ViewChild('menuTarget', { static: false })
	menuTarget: ElementRef;
	@Input() loadMenuItem: any = {};
	public machineFamilyName: string;
	public country: string;
	constantDevice = 'device';
	constantDeviceSettings = 'device-settings';
	region: string;
	public isDashboard = false;
	public countryCode: string;
	public locale: string;
	public items: Array<IMenuItem> = [];
	public showSearchBox = false;
	public showSearchMenu = false;
	public searchTips = '';
	private searchTipsTimeout: any;
	private unsupportFeatureEvt: Observable<string>;
	private subscription: Subscription;
	public selfSelectStatusVal: boolean;
	showMenu = false;
	preloadImages: string[];
	isRS5OrLater: boolean;
	hideDropDown = false;
	segment: string;

	@ViewChildren(NgbDropdown) dropDowns: QueryList<NgbDropdown>;
	private backlightCapabilitySubscription: Subscription;

	constructor(
		private router: Router,
		public configService: ConfigService,
		public commonService: CommonService,
		public languageService: LanguageService,
		public deviceService: DeviceService,
		private vantageShellService: VantageShellService,
		private logger: LoggerService,
		private keyboardService: InputAccessoriesService,
		public modalService: NgbModal,
		private adPolicyService: AdPolicyService,
		private translate: TranslateService,
		private topRowFunctionsIdeapadService: TopRowFunctionsIdeapadService,
		public dashboardService: DashboardService,
		public cardService: CardService,
		private modernPreloadService: ModernPreloadService,
		public dialogService: DialogService,
		private backlightService: BacklightService,
		private powerPage: PowerPage,
		private topRowFunctionFeature: TopRowFunctionFeature
	) {}

	ngOnInit() {
		this.checkLiteGaming();

		this.subscription = this.commonService.notification.subscribe(
			(notification: AppNotification) => {
				this.onNotification(notification);
			}
		);

		this.updateMenu(this.configService.menu);

		this.isDashboard = true;

		const cacheMachineFamilyName = this.commonService.getLocalStorageValue(
			LocalStorageKey.MachineFamilyName,
			undefined
		);
		if (cacheMachineFamilyName) {
			this.machineFamilyName = cacheMachineFamilyName;
		}

		this.initComponent();
	}

	updateMenu(menu) {
		if (menu && menu.length > 0) {
			this.items = menu;
			this.preloadImages = this.collectPreloadAssets(menu);
		}
	}

	private collectPreloadAssets(menu: Array<any>): string[] {
		let assets = [];
		menu.forEach((item) => {
			if (!item.hide && item.pre) {
				assets = assets.concat(item.pre);
			}

			if (item.subitems.length > 0) {
				assets = assets.concat(this.collectPreloadAssets(item.subitems));
			}
		});

		return assets;
	}

	private initComponent() {
		this.translate.onLangChange.subscribe((event: LangChangeEvent) => {
			if (this.translate.currentLang === 'en') {
				this.showSearchMenu = true;
			}
		});

		const machineType = this.commonService.getLocalStorageValue(
			LocalStorageKey.MachineType,
			undefined
		);
		if (machineType) {
			this.loadMenuOptions(machineType);
		} else if (this.deviceService.isShellAvailable) {
			this.deviceService.getMachineType().then((value: number) => {
				this.loadMenuOptions(value);
			});
		}
	}

	@HostListener('document:click', ['$event'])
	onClick(event) {
		const targetElement = event.target;
		if (this.menuTarget) {
			const clickedInside = this.menuTarget.nativeElement.contains(targetElement);
			const toggleMenuButton =
				targetElement.classList.contains('navbar-toggler-icon ') ||
				targetElement.classList.contains('fa-bars') ||
				targetElement.parentElement.classList.contains('fa-bars') ||
				targetElement.localName === 'path';
			if (!clickedInside && !toggleMenuButton) {
				this.showMenu = false;
			}
		}

		if (!event.fromSearchBox && !event.fromSearchMenu) {
			this.updateSearchBoxState(false);
		}
	}
	closeAllDD() {
		// Close all dropdowns
		this.dropDowns.toArray().forEach((elem) => {
			elem.close();
		});
		// Open the dropdown that was clicked on
		// activeDropdown.open();
	}

	closeAllOtherDD(activeDropdown: NgbDropdown) {
		// Close all dropdowns
		this.dropDowns.toArray().forEach((elem) => {
			if (activeDropdown !== elem) {
				elem.close();
			}
		});
	}

	showHideMenuOfItem($event, activeDropdown: NgbDropdown) {
		if (($event.shiftKey && $event.keyCode === 9) || $event.keyCode === 9) {
			const sourceElement = $event.srcElement as HTMLAnchorElement;
			const tabElements = Array.from(
				document.querySelectorAll("[tabindex]:not([tabindex='-1']")
			);
			const curElementTabIndex = tabElements.indexOf(sourceElement);
			// SHIFT+TAB
			if ($event.shiftKey && $event.keyCode === 9) {
				// if previous tabbable element not in the current active dropdown menu then close menu
				const element = tabElements[curElementTabIndex - 1] as HTMLElement;
				if (!element.getAttribute('class').includes('dropdown-item')) {
					activeDropdown.close();
				}
			}
			// TAB
			if (!$event.shiftKey && $event.keyCode === 9) {
				// if next tabbable element not in the current active dropdown menu then close menu
				const element = tabElements[curElementTabIndex + 1] as HTMLElement;
				if (!element.getAttribute('class').includes('dropdown-item')) {
					$event.stopPropagation();
					$event.preventDefault();
					element.focus();
					activeDropdown.close();
				}
			}
		}
	}

	@HostListener('window:keydown', ['$event'])
	scrollUpDown($event: KeyboardEvent) {
		if ($event.keyCode === 38 || $event.keyCode === 40) {
			const activeDom: any = document.activeElement;
			if (activeDom && activeDom.id.includes('menu-main')) {
				const contentArea = document.querySelector(
					'.vtr-app.container-fluid'
				) as HTMLElement;
				contentArea.focus();
				$event.stopPropagation();
				$event.preventDefault();
			}
		}
	}

	private loadMenuOptions(machineType: number) {
		// if IdeaPad or ThinkPad then call below function
		if (machineType === 0 || machineType === 1) {
			// add try catch for backlight exception; this is temp solution, dongwq2 should add error handle in backlight
			try {
				this.backlightCapabilitySubscription = this.backlightService.backlight
					.pipe(
						map((res) => res.find((item) => item.key === 'KeyboardBacklightLevel')),
						map((res) => res.value !== BacklightLevelEnum.NO_CAPABILITY),
						tap((res) => {
							this.commonService.setLocalStorageValue(
								LocalStorageKey.BacklightCapability,
								res
							);
						}),
						catchError(() => {
							window.localStorage.removeItem(LocalStorageKey.BacklightCapability);
							return undefined;
						})
					)
					.subscribe();
			} catch (error) {}
		}

		const machineFamily = this.commonService.getLocalStorageValue(
			LocalStorageKey.MachineFamilyName,
			undefined
		);
		// Added special case for KEI machine
		if (machineFamily) {
			const familyName = machineFamily.replace(/\s+/g, '');
			if (machineType === 1 && familyName !== 'LenovoTablet10') {
				this.initInputAccessories();
			}
		}
		this.initPowerPage();
	}

	private checkLiteGaming() {
		const filter: Promise<any> = this.vantageShellService.calcDeviceFilter({
			var: 'DeviceTags.System.Profile.LiteGaming',
		});
		if (filter) {
			filter.then((hyp) => {
				if (hyp !== null) {
					this.deviceService.isLiteGaming = true;
				} else {
					this.deviceService.isLiteGaming = false;
				}
			});
		}
	}

	ngOnDestroy() {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
		if (this.backlightCapabilitySubscription) {
			this.backlightCapabilitySubscription.unsubscribe();
		}
	}

	toggleMenu(event) {
		this.updateSearchBoxState(false);
		this.showMenu = !this.showMenu;
		this.colorPickerFun();
		event.stopPropagation();
	}

	public colorPickerFun() {
		if (this.showMenu) {
			if (document.getElementById('colorBtn')) {
				document.getElementById('colorBtn').addEventListener('click', (event) => {
					this.showMenu = false;
				});
			}
			for (let i = 0; i < 4; i++) {
				if (document.getElementById('keyboard-area' + i)) {
					document
						.getElementById('keyboard-area' + i)
						.addEventListener('click', (event) => {
							this.showMenu = false;
						});
				}
			}
		}
	}

	onKeyPress($event) {
		if ($event.keyCode === 13) {
			this.toggleMenu($event);
		}
	}

	isParentActive(item) {
		
	}

	showItem(item) {
		let showItem = true;

		if (
			item.id === 'menu-main-lnk-open-modern-preload' &&
			!this.modernPreloadService.IsEntitled
		) {
			showItem = false;
		}

		if (item.onlineOnly && !this.commonService.isOnline) {
			showItem = false;
		}

		if (item.id === 'app-search') {
			showItem = this.showSearchMenu;
		}

		if (item.hasOwnProperty('hide') && item.hide) {
			showItem = false;
		}

		if (!this.adPolicyService.IsSystemUpdateEnabled && item.id === 'device') {
			item.subitems.forEach((subitem, index, object) => {
				if (subitem.adPolicyId && subitem.adPolicyId === AdPolicyId.SystemUpdate) {
					object.splice(index, 1);
				}
			});
		}

		if (item.id === 'user') {
			showItem = false;
			item.subitems.forEach((subitem) => {
				if (this.showItem(subitem)) {
					showItem = true;
				}
			});
		}

		return showItem;
	}

	isCommomItem(item) {
		return item.id !== 'user' && item.id !== 'app-search';
	}

	updateSearchBoxState(isActive) {
		this.searchTips = '';
		this.showSearchBox = isActive;
		if (isActive && this.searchTipsTimeout) {
			this.searchTipsTimeout = clearTimeout(this.searchTipsTimeout);
			this.searchTipsTimeout = null;
		}
	}
	onFocusMenuDropDown(menuDropDown) {
		this.closeAllOtherDD(menuDropDown);
		if (!this.modalService.hasOpenModals()) {
			menuDropDown.open();
		}
	}

	onMenuItemClick(item, event?) {
		window.getSelection().empty();
		this.showMenu = false;
		if (item.id === 'app-search') {
			this.updateSearchBoxState(!this.showSearchBox);
			if (event) {
				event.fromSearchMenu = true;
			}
		} else if (item.id === 'user' && event) {
			const target = event.target || event.srcElement || event.currentTarget;
			const idAttr = target.attributes.id;
			const id = idAttr.nodeValue;
		}
	}

	onClickSearchMask() {
		this.showMenu = false;
		this.updateSearchBoxState(false);
	}

	menuItemKeyDown(path, subpath?) {
		if (path) {
			if (!subpath) {
				this.router.navigateByUrl(`/${path}`);
			} else {
				this.router.navigateByUrl(`/${path}/${subpath}`);
			}
		}
	}

	private onNotification(notification: AppNotification) {
		if (notification) {
			switch (notification.type) {
				case 'MachineInfo':
					this.machineFamilyName = notification.payload.family;
					this.commonService.setLocalStorageValue(
						LocalStorageKey.MachineFamilyName,
						notification.payload.family
					);
					this.country = notification.payload.country;
					break;
				case LocalStorageKey.MachineFamilyName:
					this.machineFamilyName = notification.payload;
					break;
				case MenuChange.MenuItemChange:
					this.updateMenu(notification.payload);
					break;
				default:
					break;
			}
		}
	}

	public openExternalLink(link) {
		if (link) {
			window.open(link);
		}
	}

	public openInternalLink(path: string) {
		if (path.includes('modern-preload')) {
			this.showMenu = false;
			this.dialogService.openModernPreloadModal();
		}
	}

	async initPowerPage() {
		if (this.commonService.getLocalStorageValue(LocalStorageKey.IsDPMSupported, false)) {
			this.logger.info('DPM page at device-settings/power path');
			this.commonService.setLocalStorageValue(LocalStorageKey.IsPowerPageAvailable, true);
		} else {
			this.logger.info('Power page at device-settings/power path');
			let icAvailable = false;
			const cache = this.commonService.getLocalStorageValue(
				LocalStorageKey.IntelligentCoolingCapability,
				undefined
			);
			if (cache) {
				const showIC = cache.showIC;
				if (+showIC > 0) {
					icAvailable = true;
				}
			}
			this.powerPage.isVisible().then((response) => {
				this.logger.info('Main Menu - initPowerPage - powerPageIsVisible ', response);
				this.commonService.setLocalStorageValue(
					LocalStorageKey.IsPowerPageAvailable,
					response
				);
			});
		}
	}

	async initInputAccessories() {
		//keyboardMap & user definedkey
		this.logger.error('MenuMainComponent.initInputAccessories before API call');
		const responses = await Promise.all([
			this.keyboardService.GetAllCapability(),
			this.keyboardService.GetKeyboardVersion(),
		]);
		try {
			if (responses) {
				this.logger.error('MenuMainComponent.initInputAccessories after API call', {
					GetAllCapability: responses[0],
					GetKeyboardVersion: responses[1],
				});
				let inputAccessoriesCapability: InputAccessoriesCapability =
					this.commonService.getLocalStorageValue(
						LocalStorageKey.InputAccessoriesCapability,
						undefined
					);
				if (inputAccessoriesCapability === undefined) {
					inputAccessoriesCapability = new InputAccessoriesCapability();
				}
				inputAccessoriesCapability.isUdkAvailable =
					responses[0] != null &&
					Object.keys(responses[0]).indexOf('uDKCapability') !== -1
						? responses[0].uDKCapability
						: false;
				inputAccessoriesCapability.isKeyboardMapAvailable =
					responses[0] != null &&
					Object.keys(responses[0]).indexOf('keyboardMapCapability') !== -1
						? responses[0].keyboardMapCapability
						: false;
				inputAccessoriesCapability.keyboardVersion =
					responses[1] != null ? responses[1] : '-1';
				this.commonService.setLocalStorageValue(
					LocalStorageKey.InputAccessoriesCapability,
					inputAccessoriesCapability
				);
			}
		} catch (error) {
			this.logger.exception('initInputAccessories', error);
		}

		this.keyboardService.getVoipHotkeysSettings().then((response) => {
			if (response.capability) {
				this.commonService.setLocalStorageValue(
					LocalStorageKey.VOIPCapability,
					response.capability
				);
			}
			return response;
		});
	}
}
